import {Record} from 'immutable';

const min = 0;
const max = 99999;

export function validate({archiveAfterDays}) {
  const archiveAfterDaysErrors = [];
  archiveAfterDays <= min && archiveAfterDaysErrors.push(`Must be greater than ${min}.`);

  archiveAfterDays >= max && archiveAfterDaysErrors.push(`Must be less than ${max}.`);

  (archiveAfterDays || '').toString().trim() === '' &&
    archiveAfterDaysErrors.push('This field is required');

  return archiveAfterDaysErrors.length > 0
    ? {
        archiveAfterDays: archiveAfterDaysErrors,
      }
    : null;
}

export default Record({
  id: null,
  name: null,
  archiveAfterDays: null,
  retainIfAnnotated: false,
  retainIfInLibrary: false,
  retainIfSharedExternally: false,
  retainIfSharedInternally: false,
  retainIfSharedWithTeam: false,
});
